import { render, staticRenderFns } from "./PotentialResourcesKey.vue?vue&type=template&id=0e707dba&scoped=true&"
import script from "./PotentialResourcesKey.vue?vue&type=script&lang=js&"
export * from "./PotentialResourcesKey.vue?vue&type=script&lang=js&"
import style0 from "./PotentialResourcesKey.vue?vue&type=style&index=0&id=0e707dba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e707dba",
  null
  
)

export default component.exports